
define('ldsh!modules/integrations/services/zapier/template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div id="zapier-wrapper">\n  <div class="zapier-notice f13 gris mb-30">\n    <p>\n      <span class="i18n" data-i18n="INTEGRATIONS.ZAPIER.NOTICE"></span>\n      <a class="i18n" data-i18n="INTEGRATIONS.ZAPIER.LBL_API_LINK;[title]INTEGRATIONS.ZAPIER.TITLE_API_LINK" title=""\n        target="_blank" href="' +
__e(mdirectorPreferencesUrl) +
'"></a>\n    </p>\n  </div>\n\n  <div id="zapier-container">\n    <div class="spinner__container" style="min-height: 400px">\n      <i class="ri-loader-4-fill fa-spin"></i>\n    </div>\n  </div>\n</div>';

}
return __p
};});

